import React, { useState, useEffect } from "react";

const SeatEditForm = ({
  selectedSeat,
  onUpdate,
  onCancel,
}) => {
  const [label, setLabel] = useState(selectedSeat?.label || "");
  const [type, setType] = useState(selectedSeat?.type || "laptop");

  useEffect(() => {
    setLabel(selectedSeat?.label || "");
    setType(selectedSeat?.type || "laptop");
  }, [selectedSeat]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate({
      label,
      type,
    });
  };

  return (
    <div className="rounded-[24px] border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-medium text-slate-950">Edit Seat</h3>
        <button
          type="button"
          onClick={onCancel}
          className="text-xs font-bold text-slate-400 hover:text-slate-600 uppercase tracking-wider"
        >
          Cancel
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Label */}
        <div>
          <label className="block text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">
            Seat Number / Label
          </label>
          <input
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm font-medium text-slate-950 focus:border-violet-500 focus:outline-none"
            placeholder="e.g. S-101"
            required
          />
        </div>

        {/* Type */}
        <div>
          <label className="block text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">
            Seat Type
          </label>
          <div className="grid grid-cols-3 gap-3">
            {["laptop", "monitor", "desktop"].map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setType(t)}
                className={`rounded-xl border px-4 py-3 text-xs font-bold capitalize transition-all ${
                  type === t
                    ? "border-black  text-black shadow-sm"
                    : "border-slate-200 bg-white text-slate-500 hover:border-slate-300"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="pt-4 flex flex-col gap-3">
          <button
            type="submit"
            className="w-full rounded-xl bg-black py-4 text-sm font-bold text-white shadow-lg transition-all active:scale-[0.98]"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default SeatEditForm;
